import Vue from "vue";
import App from "./App.vue";
import router from "./router/index";
import store from "./store";
import ElementUI from "element-ui";
import localeUI from "element-ui/lib/locale";
import defaultLang from "element-ui/lib/locale/lang/ru-RU";
import "element-ui/lib/theme-chalk/index.css";
import * as VueGoogleMaps from "vue2-google-maps";

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyAh9Mohr5pTuFAfGLjk4gtVe_80hMdWD04",
    libraries: "places",
  },
});

Vue.use(ElementUI);
localeUI.use(defaultLang);
Vue.config.productionTip = false;
document.title = "Е3 Система Управления Отходами";

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
